import request from "@/utils/request"
const projectUuids = ['c411068fa5c544609125f4a8f9293c03']
// 实时温度
export function getRoomShowave(){
    return request({
        url: '/currentBigScreen/getRoomShowave',
        method: 'post',
        data: projectUuids
    })
}
// 能耗组成占比
export function getEnergyProportion() {
    return request({
        url: '/currentBigScreen/getDeviceEnergyProportion',
        method: 'get',
        params: {
            projectUuid: 'c411068fa5c544609125f4a8f9293c03'
        }
    })
}
export function getEnergyChange() {
    return request({
        url: '/currentBigScreen/getEnergyChange',
        method: 'post',
        data: projectUuids
    })
}
// 冷间面积分布
export function getRoomArea() {
    return request({
        url: '/currentBigScreen/getRoomArea',
        method: 'post',
        data: projectUuids
    })
}
// 获取冷间运行时长
export function getRoomRunTime() {
    return request({
        url: '/currentBigScreen/getRoomRunTime',
        method: 'post',
        data: projectUuids
    })
}
// 查询项目城市当前温度湿度
export function getProjectWeatherData() {
    return request({
        url: '/currentBigScreen/getProjectWeatherData',
        method: 'get',
        params: {
            projectUuid: 'c411068fa5c544609125f4a8f9293c03'
        }
    })
}
// // 大屏简介
// export function getBriefIntroduction() {
//     return request({
//         url: '/currentBigScreen/getBriefIntroduction',
//         method: 'get',
//     })
// }

// 获取告警列表
export function getAlarmList() {
    return request({
        url: '/currentBigScreen/getAlarmData',
        method: 'post',
        data: {
            projectUuid: 'c411068fa5c544609125f4a8f9293c03',
            alarmState: 0,
        }
    })
}
